import { FC } from 'react';
import logo from './logo.svg';
import { Box } from '@material-ui/core';

interface DefaultLogoProps {
  style?: object;
}

export const DefaultLogo: FC<DefaultLogoProps> = ({ style }) => {
  return (
    <Box
      style={{
        height: '100%',
        width: '100%',
        gap: '4px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <img
        style={{ maxHeight: '100%', ...style }}
        src={logo}
        alt="logo witboost"
      />
    </Box>
  );
};
